























import Vue from 'vue'
import RecentWorkItem from './RecentWorkItem.vue'

export default Vue.extend({
  components: {
    RecentWorkItem
  }
})
